import { useContext, useEffect } from "react";
import ToastContext from "../../context/toastProvider";
import LoadingScreen from "../utils/loadingScreen";
import PricingEditor from "./pricingEditor";
import PricingHistory from "./pricingHistory";
import PricingSimulator from "./pricingSimulator";
import usePricingEditor from "./usePricingEditor";

const Pricing = ({ user }) => {
    const { badToast } = useContext(ToastContext);
    const token = user?.token;
    const editor = usePricingEditor({ token });
    const {
        status,
        draft,
        activeVersion,
        versions,
        diff,
        isDirty,
        validationErrors,
        simulation,
        setProductField,
        setPriorityField,
        setFeeField,
        toggleProductActive,
        togglePriorityActive,
        runSimulation,
        publish,
        activateVersion,
    } = editor;

    useEffect(() => {
        if (status === "error") {
            badToast("Não foi possível carregar a configuração de preços.");
        }
    }, [status, badToast]);

    if (status === "loading") {
        return <LoadingScreen />;
    }

    if (status === "error") {
        return (
            <main className="p-4 text-center">
                <h1 className="text-2xl font-semibold text-[#d59106]">Precificação</h1>
                <p className="mt-4 text-red-300">Não foi possível carregar a configuração de preços.</p>
            </main>
        );
    }

    return (
        <main className="p-4">
            <h1 className="mb-4 text-center text-2xl font-semibold text-[#d59106]">Precificação</h1>
            <div className="grid grid-cols-1 gap-6 lg:grid-cols-[minmax(0,1.4fr)_minmax(0,1fr)]">
                <PricingEditor
                    draft={draft}
                    diff={diff}
                    isDirty={isDirty}
                    validationErrors={validationErrors}
                    setProductField={setProductField}
                    setPriorityField={setPriorityField}
                    setFeeField={setFeeField}
                    toggleProductActive={toggleProductActive}
                    togglePriorityActive={togglePriorityActive}
                    publish={publish}
                />
                <div className="space-y-6">
                    <PricingSimulator draft={draft} simulation={simulation} runSimulation={runSimulation} />
                    <PricingHistory versions={versions} activeVersion={activeVersion} activateVersion={activateVersion} />
                </div>
            </div>
        </main>
    );
};

export default Pricing;
